import React from 'react'
import PropTypes from 'prop-types'
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles
} from '@material-ui/core/styles'
import orange from '@material-ui/core/colors/orange'
import { styles } from '../containers/dockPadStyle'
import classNames from 'classnames'

let DockPadChip = props => {
  const { disabled } = props

  const pillClass = !!disabled
    ? props.disabledPill
    : props.classes[props.variant]
  return (
    <div className={classNames(props.classes.chipBackground, pillClass)}>
      <span className={classNames(props.classes.chipText, pillClass)}>
        {props.label}
      </span>
    </div>
  )
}

DockPadChip.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['yellow', 'blue', 'green', 'red']).isRequired,
  disabled: PropTypes.bool
}

DockPadChip = withStyles(styles)(DockPadChip)

function CustomStyles(props) {
  const { label, variant } = props
  return (
    <MuiThemeProvider
      theme={theme =>
        createMuiTheme({
          ...theme,
          palette: {
            ...theme.palette,
            primary: {
              main: orange[500]
            }
          }
        })
      }>
      <DockPadChip variant={variant} label={label} />
    </MuiThemeProvider>
  )
}

export default CustomStyles



// WEBPACK FOOTER //
// ./src/components/DockPadChips.tsx